<script>
    import { Svroller } from 'svrollbar'
    import { fade } from 'svelte/transition'
    import { writable } from 'svelte/store'
    import { onMount } from 'svelte'
    // export let viewport = null;
    const obj = writable(null)
    export let alwaysVisible = false
    export let width = '1px'
    export let height = '1px'
    const trackObj = (node) => {
        obj.update((n) => node.parentNode.parentNode.parentNode)
        return fade(node, {})
    }
    // $: if($obj) {
    //   setTimeout(_ => {}, 250);
    //   width = $obj.clientWidth+'px'
    //   height = $obj.clientHeight+'px'
    //   console.log(width, height)
    // };
</script>

<Svroller
    initiallyVisible
    {width}
    {height}
    vTrackIn={trackObj}
    vTrackOut={trackObj}
    {alwaysVisible}
>
    <slot />
</Svroller>

<style>
    :root {
        --svrollbar-track-width: 9px;
        --svrollbar-track-background: rgb(0, 0, 0);
        --svrollbar-track-radius: 4px;
        --svrollbar-track-opacity: 0.08;
        --svrollbar-track-shadow: initial;
        --svrollbar-thumb-width: 9px;
        --svrollbar-thumb-background: rgb(0, 0, 0);
        --svrollbar-thumb-radius: 4px;
        --svrollbar-thumb-opacity: 0.28;
        --svrollbar-thumb-shadow: initial;
    }
    /* .gradient {
    width: 100%;
    height: 15%;
    position: sticky;
    background: linear-gradient(180deg, #FFFFFF 8.85%, rgba(255, 255, 255, 0) 100%);
  } */
</style>
